import React, { useState } from "react";
import style from "./cargoModalTab.module.scss";
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { useDrag } from 'react-dnd'

const TimeCard = (props) => {

    const [{ isDragging }, dragRef] = useDrag({
        type: props.type,
        item: {
            type: props.type,
            value: props.data.value,
            id: props.data.id,
            index: props.index
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()

            if (item && dropResult) {
                props.onDropTimeRange(item)
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    })

    return (
        <div
            className={style.dragItem}
            ref={dragRef}
            onClick={() => props.onDropTimeRange({
                type: props.type,
                value: props.data.value,
                id: props.data.id,
                index: props.index
            })}
        >
            {toPersianNumber(props.data.value)}
        </div>
    );

}

export default TimeCard;